import React from "react";
import styles from "./ButtonIntroWide.module.scss";

function ButtonIntroWide({ title, theme = "green", onClick }) {
  const buttonClass = `${styles["card-button"]} ${styles[`theme--${theme}`]}`;

  return (
    <button className={buttonClass} onClick={onClick}>
        <h3 className={styles["title"]}>{title}</h3>
    </button>
  );
}

export default ButtonIntroWide;
